import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import type {Context} from 'src/common/types'
import {HeadingSection as DefaultHeadingSection} from './HeadingSection'

export type HeadingSectionProps = SliceComponentProps<Content.HeadingSectionSlice>

const HeadingSection = ({
  slice,
  context: {pageUid},
  index: componentIndex,
}: HeadingSectionProps & {context: Context}): JSX.Element | null => {
  switch (slice.variation) {
    case 'default':
      return <DefaultHeadingSection slice={slice} pageUid={pageUid} componentIndex={componentIndex} />
    default:
      return null
  }
}

export default HeadingSection
